module.exports = __webpack_public_path__ + "img/97.6.683e361b.png";